module.exports = __webpack_public_path__ + "static/media/za.67ff2e10.svg";